import api from '@/js/services/api';

export default {
    lockPeriod(id) {
        return api().post(`/master-admin/timesheets/periods/${id}/lock`,)
    },

    printTimeSheets(ids) {
        return api().get(`/master-admin/timesheets/print`, {
            params: { timesheetsIds: ids }
        })
    },

    getPeriods(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get('/master-admin/timesheets/periods/get?' + searchParams.toString())
    },

    getEmployeeListOfPeriods(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get('/applicant/timesheets/periods/get?' + searchParams.toString())
    },

    getTimesheets(period_id, filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/master-admin/timesheets/periods/${period_id}/timesheets/get?` + searchParams.toString())
    },

    saveCustomTimesheet(periodId, info) {
        return api().post(`/master-admin/timesheets/periods/${periodId}/timesheets/custom/store`, info)
    },

    storeTimesheetFile(periodId, payload) {
        return api().post(`/master-admin/timesheets/periods/${periodId}/create-from-file`, payload )
    },

    deleteTimesheetFile(id, file_id) {
        return api().delete(`/master-admin/applicants/${id}/attachments/${file_id}/delete`);
    },

    getFileInfo(periodId, formData) {
        return api().post(`/master-admin/timesheets/periods/${periodId}/upload`, formData)
    },

    updateTimesheetStatus(period_id, timesheet_id, status) {
        return api().post(`/master-admin/timesheets/periods/${period_id}/timesheets/${timesheet_id}/status/update`, {status})
    },

    updateTimesheetByAdmin(periodId, timesheetId, info) {
        return api().put(`/master-admin/timesheets/periods/${periodId}/timesheets/${timesheetId}/update`, info)
    },

    updateTimesheetByEmployee(periodId, timesheetId, info) {
        return api().put(`/applicant/timesheets/periods/${periodId}/timesheets/${timesheetId}/update`, info)
    },

    submitTimesheetByEmployee(periodId, timesheetId) {
        return api().post(`/applicant/timesheets/periods/${periodId}/timesheets/${timesheetId}/submit`)
    }


}
